module.exports = __webpack_public_path__ + "img/card.45852ffa.png";